<template>
  <div>
    <div v-if="+albumType !== 1" class="f-b-c">
      <div>
        <el-button v-if="form.type === 1" size="medium" type="primary" @click="$emit('showIntelligentSet')">智能添加配置</el-button>
        <el-button v-if="form.type === 2" size="medium" type="primary" @click="selectGoods()">选择商品</el-button>
        <el-button v-if="form.type === 2 && manual.length && form.level === 2 && manualForm.groupName" size="medium" type="primary" style="margin-left:16px" @click="$emit('handleTabsAdd')">新增分组</el-button>
        <el-select v-if="goodsList.length && form.type === 2" size="medium" v-model="country" style="width:180px;margin-left:16px" placeholder="选择发货国家设置" clearable @change="setAlbumModuleProduct()">
          <el-option v-for="item in countryList" :key="item.country" :value="item.country" :label="item.countryCn" />
        </el-select>
        <el-dropdown v-if="goodsList.length" placement="bottom-start" style="margin-left:16px;" @command="command=>handleCommand(command)">
          <el-button size="medium">
            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">批量修改优先级</el-dropdown-item>
            <el-dropdown-item :command="2" :disabled="form.type === 1">批量删除商品</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="manual.length && form.level === 2" size="medium" type="text" style="margin-left:16px;" @click="editManual">修改分组</el-button>
        <el-popconfirm
          v-if="form.level === 2 && manual.length > 1"
          icon="el-icon-info"
          title="确定要删除当前分组吗！"
          @confirm="deleteManual"
        >
          <el-button size="medium" type="text" slot="reference" style="margin-left:16px;">删除分组</el-button>
        </el-popconfirm>
        
        
        <el-tooltip v-if="selectIds.length" effect="dark" content="Bottom Left 提示文字" placement="bottom-start">
          <el-button size="medium" type="text" @click="resetGoods" style="margin-left:16px;">取消选中</el-button>
        </el-tooltip>
      </div>
      <div>
        <el-popover placement="bottom" trigger="click" width="360">
          <el-input v-model="searchArray" size="medium" clearable placeholder="支持批量搜索(英文逗号隔开)" @change="searchChange" slot="reference" style="width:340px">
            <el-button slot="append" icon="el-icon-search" @click="searchChange" style="height: 36px" />
          </el-input>
          <el-input v-model="searchArray" type="textarea" resize="none" :rows="6" placeholder="支持批量搜索(英文逗号隔开)" @blur="searchChange" />
        </el-popover>
        <el-select v-model="defaultSort" size="medium" style="width:150px;margin-left:16px" @change="setAlbumModuleProduct('sort')">
          <el-option :value="1" label="上架时间升序"></el-option>
          <el-option :value="2" label="上架时间倒序"></el-option>
          <el-option :value="3" label="总销量升序"></el-option>
          <el-option :value="4" label="总销量倒序"></el-option>
          <el-option :value="5" label="价格升序"></el-option>
          <el-option :value="6" label="价格倒序"></el-option>
          <el-option :value="7" label="手动排序"></el-option>
        </el-select>
      </div>
    </div>
    <div v-else class="f-b-c">
      <div>
        <el-dropdown v-if="goodsList.length" placement="bottom-start" @command="command=>handleCommand(command)">
          <el-button size="medium">
            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">批量修改优先级</el-dropdown-item>
            <el-dropdown-item :command="2" :disabled="true">批量删除商品</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-tooltip v-if="selectIds.length" effect="dark" content="Bottom Left 提示文字" placement="bottom-start">
          <el-button size="medium" type="text" @click="resetGoods" style="margin-left:16px;">取消选中</el-button>
        </el-tooltip>
      </div>
      <div>
        <el-popover placement="bottom" trigger="click" width="360">
          <el-input v-model="searchArray" size="medium" clearable placeholder="支持批量搜索(英文逗号隔开)" @change="searchChange" slot="reference" style="width:340px">
            <el-button slot="append" icon="el-icon-search" @click="searchChange" style="height: 36px" />
          </el-input>
          <el-input v-model="searchArray" type="textarea" resize="none" :rows="6" placeholder="支持批量搜索(英文逗号隔开)" @blur="searchChange" />
        </el-popover>
      </div>
    </div>
    <!-- <div v-else-if="+albumType !== 1" class="f--c f-e">
      <div>
        商品排序：
        <el-select v-model="defaultSort" size="small" style="width:160px" @change="setAlbumModuleProduct('sort')">
          <el-option :value="1" label="上架时间升序"></el-option>
          <el-option :value="2" label="上架时间倒序"></el-option>
          <el-option :value="3" label="总销量升序"></el-option>
          <el-option :value="4" label="总销量倒序"></el-option>
          <el-option :value="5" label="价格升序"></el-option>
          <el-option :value="6" label="价格倒序"></el-option>
          <el-option :value="7" label="手动排序"></el-option>
        </el-select>
      </div>
    </div> -->

    <div>
      <!-- <el-table v-loading="loading" :data="goodsList" :max-height="manualForm.level === 1 ? 'calc(100vh - 280px)':'600px'" row-key="id">
        <el-table-column label="商品图片" :width="100">
          <template slot-scope="{row}">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.imgUrl" fit="cover" />
              <el-image slot="reference" :src="row.imgUrl" fit="cover" class="stock-img" />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="商品名称"></el-table-column>
        <el-table-column prop="spuCode" label="SPU"></el-table-column>
        <el-table-column prop="stock" label="可用库存" :width="100"></el-table-column>
        <el-table-column prop="sort" label="排序优先级" :width="220">
          <template slot-scope="{row}">
            <el-input-number v-model="row.sort" :precision="0" :min="1" @change="editHandle('sort', row)"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="操作" :width="150" v-if="+albumType !== 1">
          <template slot-scope="{row}">
            <el-button type="text" @click="editHandle('delete', row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table> -->
      <div v-loading="loading">
        <div v-if="!loading && !goodsList.length" style="margin: 10px auto;text-align:center;">暂无产品</div>
        <goods v-else ref="goodsComp" :data="goodsList" :show-fixed="false" :show-delete="+albumType !== 1 && form.type === 2" :showPriority="true" :avoidImplicitDeselect="true" @isTop="onIsTopGood" @delete="onDeleteGood" @select="onSelect" @end="onEnd" @changePriority="changePriority" style="margin-top:20px" />
      </div>

      <div class="f-b-c bg-white" style="padding: 12px">
        <div>
          <el-popconfirm
            v-if="!$route.query.id"
            title="确定要清除已选设置么？"
            @confirm="backFirstStep"
          >
            <!-- <el-button slot="reference" size="medium">清空已选，上一步</el-button> -->
          </el-popconfirm>
          <!-- <el-button v-if="$route.query.id && process !== 3" size="medium" @click="$router.back()">返回专辑列表</el-button> -->
        </div>
        <el-pagination small background :current-page="listParams.pageNumber" :page-sizes="[40, 50, 100, 200, 500]" :page-size="listParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
      </div>
    </div>

    <select-goods v-if="process !== 3" ref="selectGoods" @getList="getList" />
    <batch-priority ref="batchPriority" :selectIds="selectIds" :pageSize="listParams.pageSize" :total="total" @changePriority="changePriority"></batch-priority>
  </div>
</template>

<script>
import _ from 'lodash'
import API from '@/api'
import selectGoods from './selectGoods.vue'
import Goods from '@/components/Goods.vue'
import BatchPriority from './batchPriority.vue'
import AddGroup from './addGroup.vue'
export default {
  components: { selectGoods, Goods, BatchPriority, AddGroup },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    manual: {
      type: [Array, Object],
      default: () => []
    },
    manualForm: {
      type: Object,
      default: () => {}
    },
    albumType: {
      type: [Number, String],
      default: () => ''
    },
    countryList: {
      type: Array,
      default: () => []
    },
    process: {
      type: [Number, String],
      default: () => ''
    }
  },
  data() {
    return {
      loading: false,
      listParams: {
        pageNumber: 1,
        pageSize: 50,
        moduleRuleId: undefined,
        groupId: undefined,
        order: undefined,
        searchName: undefined
      },
      total: 0,
      goodsList: [],
      country: undefined, // 选择仓库国家
      defaultSort: 4, // 排序方式

      searchArray: undefined,
      selectIds: []
    }
  },
  created() {
    
  },
  mounted() {
    this.show()
  },
  methods:{
    show() {
      this.$set(this.listParams, 'moduleRuleId', this.manualForm.moduleRuleId||undefined)
      this.$set(this.listParams, 'groupId', this.manualForm.groupId||undefined)
      this.$set(this.listParams, 'groupName', this.manualForm.groupName||undefined)
      this.$set(this.listParams, 'moduleId', this.manualForm.moduleId||undefined)
      this.country = this.manualForm.country
      this.defaultSort = this.manualForm.defaultSort
      this.$set(this.listParams, 'pageNumber', 1)
      this.$set(this.listParams, 'pageSize', 50)
      this.getAlbumModuleProductList()
    },
    selectGoods() {
      if (!this.manualForm.groupName && this.form.level === 2) {
        this.$message.warning('请选输入分组名称')
        this.editManual()
        return
      }
      this.$refs.selectGoods.show(this.manualForm)
    },
    // 新增专辑回调
    getList(groupId) {
      // this.listParams.pageNumber = 1
      if (groupId) {
        this.$set(this.manualForm, 'groupId', groupId)
        this.$set(this.listParams, 'groupId', groupId)
      }
      if (this.form.type && !this.$route.query.id) {
        let parentRule = this.$parent.form.rule
        let group = {
          groupId: this.manualForm.groupId,
          groupName: this.manualForm.groupName || undefined,
          defaultSort: this.defaultSort || 4
        }
        if (this.form.level === 1) parentRule.group = [group]
      }
      this.getAlbumModuleProductList()
    },
    // 专辑列表
    getAlbumModuleProductList() {
      this.loading = true
      API.getAlbumModuleProductList(this.listParams).then(res => {
        if (res.code !== 10000) return this.$message.warning(res.message)
        this.goodsList = res.data.list.map(item => ({
          kkProductId: item.kkProductId,
          id: item.kkProductId,
          images: item.images,
          spuCode: item.spuCode,
          price: item.price,
          uid: item.id,
          status: item.status,
          priority: item.orderNum
        }))
        this.total = res.data.total

        this.$nextTick(() => {
          this.resetGoods()
        })
      }).finally(() => {
        this.loading = false
      })
    },
    // 设置专辑
    editHandle(type, row) {
      let param = {
        moduleId: this.manualForm.moduleId,
        moduleRuleId: this.manualForm.moduleRuleId,
        groupId: this.manualForm.groupId,
        groupName: this.manualForm.groupName
      }
      if (type === 'delete') {
        // param.delete = [{
        //   kkProductId: row.kkProductId,
        //   id: row.id
        // }]
        param.delete = row.kkProductIds
      }
      if (type === 'sort') {
        param.update = [{
          kkProductId: row.kkProductId,
          sort: row.sort,
          id: row.id
        }]
      }
      API.setAlbumModuleProduct(param).then(res => {
        this.$message.success('操作成功')
        this.getList()
      })
    },
    // 返回第一步
    backFirstStep() {
      this.$emit('backFirstStep')
    },
    pageChange(page) {
      this.listParams.pageNumber = page
      this.getAlbumModuleProductList()
    },
    handleSizeChange(size) {
      this.listParams.pageSize = size
      this.pageChange(1)
    },

    // 设置商品
    setAlbumModuleProduct(type) {
      let param = {
        moduleId: this.manualForm.moduleId,
        moduleRuleId: this.manualForm.moduleRuleId,
        groupId: this.manualForm.groupId,
        groupName: this.manualForm.groupName,
        country: this.country,
        defaultSort: this.defaultSort
      }
      // 切换了商品排序后要将排序赋值到manualForm上，因为这个对象要传到选择商品的弹框里面
      this.manualForm.defaultSort = this.defaultSort
      API.setAlbumModuleProduct(param).then(res => {
        if (res.code === 10000) {
          this.$set(this.manualForm, 'country', this.country)
          this.$emit('updateManual', param)
          this.$message.success('操作成功')
          if (type === 'sort') this.getList()
        }
     })
    },

    /**
    * 点击置顶ICon的回调事件
    *
    * @param {Object} good 当前点击的商品
    */
    onIsTopGood(good) {
      // console.log(good)
    },

    /**
    * 点击删除ICon的回调
    *
    * @param {Object} good 当前点击的商品
    */
    onDeleteGood(good) {
      this.editHandle('delete', { ...good, kkProductIds: [good.id], id: good.uid })
    },

    /**
    * 选中商品时触发的事件回调
    *
    * @param {Array} selectIds 当前选中的商品IDs
    */
    onSelect(selectIds) {
      this.selectIds = selectIds
    },

    /**
    * 拖拽结束后触发的事件回调
    *
    * @param {Array} selectIds 当前选中的商品IDs
    * @param {Array} sortIds 当前列表排序后的IDs（未包含置顶元素）
    * @param {Array} ids 当前列表排序后的IDs
    */
    onEnd(selectIds, sortIds, ids) {
      let param = {
        moduleId: this.manualForm.moduleId,
        moduleRuleId: this.manualForm.moduleRuleId,
        groupId: this.manualForm.groupId,
        groupName: this.manualForm.groupName,
        country: this.manualForm.country,
        defaultSort: 7
      }
      param.pageNumber = this.listParams.pageNumber
      param.pageSize = this.listParams.pageSize
      param.update = ids
      this.defaultSort = 7
      if (this.searchArray) {
        param.params = JSON.stringify({searchNameArrays: Array.isArray(this.searchArray) ? this.searchArray : this.searchArray.replace(/[；,，;\s\r\n]+/g, ',').split(',')})
      }
      API.setAlbumModuleProduct(param).then(res => {
        this.$message.success('操作成功')
         this.$emit('updateManual', param)
        this.getList()
      })
    },

    // 批量操作
    handleCommand(command) {
      if (!this.selectIds.length) return this.$message.warning('请先选择商品！') 
      switch (command) {
        case 1:
          this.$refs.batchPriority.show()
          return
        case 2:
          this.$confirm('确定要删除选择的商品吗', {
            type: 'warning'
          }).then(() => {
            this.editHandle('delete', { kkProductIds: this.selectIds })
          })
          return
      }
    },

    // 删除分组
    deleteManual() {
      this.$emit('deleteManual', { groupId: this.manualForm.groupId, changeTabs: true }, this.manual.findIndex(t => t.groupId === this.manualForm.groupId))
    },
    editManual() {
      this.$emit('editManual')
    },
    searchChange() {
      if (this.searchArray) {
        this.listParams.searchName = Array.isArray(this.searchArray) ? this.searchArray : this.searchArray.replace(/[；,，;\s\r\n]+/g, ',').split(',')
      } else this.listParams.searchName = undefined
      this.pageChange(1)
    },
    // 重置拖拽组件
    resetGoods() {
      this.$refs.goodsComp.destroySortable()
    },
    // 修改优先级
    changePriority(param) {
      param.moduleId = this.manualForm.moduleId
      param.moduleRuleId = this.manualForm.moduleRuleId
      param.groupId = this.manualForm.groupId
      param.groupName = this.manualForm.groupName
      if (param.update.length>1) {
        let update = []
        this.goodsList.forEach(t => {
          if (param.update.includes(t.id)) update.push(t.id)
        })
        param.update = update
      }
      API.priorityAlbumModule(param).then(res => {
        this.defaultSort = 7
        this.$emit('updateManual', {...param, defaultSort: 7})
        this.$message.success('操作成功')
        this.getList()
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.stock-img{
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #f5f7fa;
  user-select: none;
  cursor: pointer;
}
</style>